<template>
  <button v-if="isPresenterMode && hasHistory" class="btn btn--primary fixed left-2 top-2 z-50" @click="goBack">
    <InlineSvg path="icons/chevron-left" aria-hidden="true" />
    {{ $t('Back') }}
  </button>
</template>

<script setup>
import { computed, getCurrentInstance } from 'vue'
import InlineSvg from 'vue_features/shared/components/ui/InlineSvg'

const emit = defineEmits(['exitPresenter'])
const vm = getCurrentInstance()

const hasHistory = typeof window !== 'undefined' && window.history.length > 0

const isPresenterMode = computed(() => {
  return (
    typeof window !== 'undefined' &&
    !(window.statusbar?.visible && window.toolbar?.visible && window.locationbar?.visible)
  )
})

function goBack() {
  if (vm?.vnode?.props?.onExitPresenter) {
    emit('exitPresenter')
  } else {
    if (window.history.length > 1) {
      window.history.back()
    } else {
      window.location.href = '/'
    }
  }
}
</script>
